import { useState } from "react";
import Nftcard from "./nftCard";
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { contractAddress } from "../config";
import ContractAbi from '../Assets/Abi/auction.json'
import { MySigner, getContract } from "../hooks/getContract";
import { Signer, ethers } from "ethers";
import { useAccount } from "wagmi";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { formatEther, parseEther } from "viem";
import NFT from '../Assets/nft1.jpg'
import ComputersCanvas from "./three";

export default function Home() {

    const { address, isConnected } = useAccount()

    // For Mint Model
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    // For Sale Model 
    const [open2, setOpen2] = useState(false);
    const handleOpen2 = () => setOpen2(true);
    const handleClose2 = () => setOpen2(false);


    // Import Nft
    const [open3, setOpen3] = useState(false);
    const handleOpen3 = () => setOpen3(true);
    const handleClose3 = () => setOpen3(false);

    const test = isConnected ? MySigner : null
    // Mint function 
    const AuctionContract = getContract(test)

    async function Mint(e) {
        e.preventDefault();
        if (address) {
            try {
                const tokenUri = e.target.tokenuri.value
                const id = await AuctionContract.mintNFT(tokenUri)
                handleClose()
                await toast.promise(id.wait(), {
                    pending: 'Minting...',
                    success: 'Successfully minted',
                    error: 'Failed to mint',
                });


            } catch (error) {
                toast.error(error.reason ? error.reason : error.data ? error.data.message : error.message)
                console.log(error);
            }
        }
        else {
            toast.info("Connect Wallet")
        }

    }

    async function importNFT(e) {
        e.preventDefault();
        if (address) {

            try {
                const tokenUri = e.target.tokenid.value
                const result = await window.ethereum.request({
                    method: 'wallet_watchAsset',
                    params: {
                        type: 'ERC721',
                        options: {
                            address: contractAddress,
                            tokenId: tokenUri.toString(),
                        },
                    },
                });

                if (result) {
                    console.log('NFT imported successfully');
                } else {
                    console.log('NFT import canceled by the user');
                }
            } catch (error) {
                toast.error(error.reason ? error.reason : error.data ? error.data.message : error.message)

                console.error('Error importing NFT:', error);
            }
        } else {
            toast.info("Connect Wallet")
        }
    }



    // List for sale 
    async function ListForSale(e) {

        e.preventDefault();
        if (address) {

            try {
                const tokenId = e.target.tokenId.value
                const basePrice = parseEther(e.target.price.value)
                const duration = e.target.duration.value

                const id = await AuctionContract.createAuction(tokenId, duration, basePrice)
                handleClose2()
                await toast.promise(id.wait(), {
                    pending: 'Listing for sale...',
                    success: 'Successfully Listed',
                    error: 'Failed to List',
                });

            } catch (error) {
                toast.error(error.reason ? error.reason : error.data ? error.data.message : error.message)
                console.log(error);
            }
        } else {
            toast.info("Connect Wallet")
        }

    }

    return (
        <>
            <div className="App">
                <ToastContainer
                    position="bottom-right"
                />
                <header className="App-header">
                    {/* <ComputersCanvas/> */}
                    <div className="flex min-h-screen w-full flex-col overflow-hidden">
                        <div className="grow">
                            <section className="relative h-[20vh] min-h-[200px] w-full  bg-center">
                                {/* <div className="absolute -bottom-1/2 left-1/2 box-border h-32 w-32 -translate-x-1/2 -translate-y-1/2 rounded-md border-4 border-slate-300 bg-[url('/public/nft.gif')]  bg-cover sm:h-40 sm:w-40" style={{ width: "273px" }}></div> */}
                                <div className="absolute -bottom-1/2 left-1/2 box-border h-32 w-32 -translate-x-1/2 -translate-y-1/2 rounded-md border-2 border-slate-300 bg-cover sm:h-40 sm:w-40" style={{ width: "273px" }}>
                                    <img src={NFT} alt="Your Image" className="w-full h-full rounded-md" />
                                </div>
                            </section>
                            <section>
                                <div className="container mx-auto">
                                    <div className="py-20 text-center">
                                        <h2 className="text-3xl font-bold text-white">Decentralized NFT Auction</h2>
                                        <p>
                                            <span className="text-md font-bold text-slate-500">
                                                by    ArtChainAuction
                                            </span>
                                        </p>
                                    </div>
                                    <button className="btn m-auto" type="button" onClick={handleOpen}>
                                        <strong>Mint NFT</strong>
                                        <div id="glow">
                                            <div class="circles"></div>
                                            <div class="circles"></div>
                                        </div>
                                    </button>
                                    <br />
                                    <br />
                                    <button className="btn m-auto" type="button" onClick={handleOpen2}>
                                        <strong>List Nft for sale</strong>
                                        <div id="glow">
                                            <div class="circles"></div>
                                            <div class="circles"></div>
                                        </div>
                                    </button>
                                    <br />
                                    <br />
                                    <button className="btn m-auto" type="button" onClick={handleOpen3}>
                                        <strong>Import NFT</strong>
                                        <div id="glow">
                                            <div class="circles"></div>
                                            <div class="circles"></div>
                                        </div>
                                    </button>
                                    <Nftcard />


                                    {/* Mint Model */}
                                    <Modal
                                        open={open}
                                        onClose={handleClose}
                                        aria-labelledby="modal-modal-title"
                                        aria-describedby="modal-modal-description"
                                    >
                                        <div className="login-box">
                                            <div className="closein" onClick={handleClose}>
                                                <CloseIcon style={{ color: 'white' }} />
                                            </div>
                                            <br />
                                            <form onSubmit={Mint}>
                                                <div className="user-box">
                                                    <input type="text" name="tokenuri" required="" />
                                                    <label>Enter Token URI</label>
                                                </div>

                                                <center>
                                                    <button type="submit">
                                                        Mint
                                                        <span />
                                                    </button>
                                                </center>
                                            </form>
                                        </div>
                                    </Modal>
                                    {/* nft */}
                                    <Modal
                                        open={open3}
                                        onClose={handleClose3}
                                        aria-labelledby="modal-modal-title"
                                        aria-describedby="modal-modal-description"
                                    >
                                        <div className="login-box">
                                            <div className="closein" onClick={handleClose3}>
                                                <CloseIcon style={{ color: 'white' }} />
                                            </div>
                                            <br />
                                            <form onSubmit={importNFT}>
                                                <div className="user-box">
                                                    <input type="text" name="tokenid" required="" />
                                                    <label>Enter Token Id</label>
                                                </div>

                                                <center>
                                                    <button type="submit">
                                                        Import
                                                        <span />
                                                    </button>
                                                </center>
                                            </form>
                                        </div>
                                    </Modal>

                                    {/* Sale Model */}
                                    <Modal
                                        open={open2}
                                        onClose={handleClose2}
                                        aria-labelledby="modal-modal-title"
                                        aria-describedby="modal-modal-description"
                                    >
                                        <div className="login-box">
                                            <div className="closein" onClick={handleClose2}>
                                                <CloseIcon style={{ color: 'white' }} />
                                            </div>
                                            <h1 style={{ color: 'white', textAlign: 'center', fontSize: '18px' }}>List for sale</h1>
                                            <br />
                                            <form onSubmit={ListForSale}>
                                                <div className="user-box">
                                                    <input type="text" name="tokenId" required="" />
                                                    <label>Token ID</label>
                                                </div>
                                                <div className="user-box">
                                                    <input type="text" name="price" required="" />
                                                    <label>Starting price</label>
                                                </div>
                                                <div className="user-box">
                                                    <FormControl fullWidth>
                                                        <InputLabel id="demo-simple-select-label" >Duration</InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-label"
                                                            id="demo-simple-select"
                                                            name="duration"
                                                            style={{ color: 'white' }}
                                                        >
                                                            <MenuItem value={3600}>1 Hour</MenuItem>
                                                            <MenuItem value={21600}>6 Hour</MenuItem>
                                                            <MenuItem value={86400}>1 Day</MenuItem>
                                                            <MenuItem value={259200}>3 Day</MenuItem>
                                                            <MenuItem value={604800}>7 Day</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </div>

                                                <center>
                                                    <button type="submit">
                                                        List
                                                        <span />
                                                    </button>
                                                </center>
                                            </form>
                                        </div>
                                    </Modal>

                                </div>
                            </section>
                        </div>
                    </div>
                </header>
            </div>
        </>
    )
}